class NovvaStoreLocator extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;
    this.dataset.initialized = 'true';

    this.cityFilter = this.querySelector('[data-city-filter]');
    this.districtFilter = this.querySelector('[data-district-filter]');
    this.searchInput = this.querySelector('[data-store-search]');
    this.cards = Array.from(this.querySelectorAll('[data-store-card]'));
    this.resultCount = this.querySelector('[data-result-count]');
    this.clearButton = this.querySelector('[data-clear-filters]');
    this.emptyState = this.querySelector('[data-empty-state]');

    this.cityFilter?.addEventListener('change', () => {
      this.updateDistrictOptions();
      this.filterStores();
    });
    this.districtFilter?.addEventListener('change', () => this.filterStores());
    this.searchInput?.addEventListener('input', () => this.filterStores());
    this.clearButton?.addEventListener('click', () => this.clearFilters());

    this.updateDistrictOptions();
    this.filterStores();
  }

  normalize(value) {
    return String(value || '')
      .toLocaleLowerCase('tr-TR')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim();
  }

  updateDistrictOptions() {
    if (!this.cityFilter || !this.districtFilter) return;
    const city = this.cityFilter.value;
    Array.from(this.districtFilter.options).forEach((option) => {
      if (!option.value) return;
      option.hidden = Boolean(city && option.dataset.city !== city);
    });

    const selected = this.districtFilter.selectedOptions[0];
    if (selected?.hidden) this.districtFilter.value = '';
  }

  filterStores() {
    const city = this.cityFilter?.value || '';
    const district = this.districtFilter?.value || '';
    const query = this.normalize(this.searchInput?.value);
    let visibleCount = 0;

    this.cards.forEach((card) => {
      const cityMatch = !city || card.dataset.city === city;
      const districtMatch = !district || card.dataset.district === district;
      const searchMatch = !query || this.normalize(card.dataset.search).includes(query);
      const visible = cityMatch && districtMatch && searchMatch;
      card.hidden = !visible;
      if (visible) visibleCount += 1;
    });

    if (this.resultCount) this.resultCount.textContent = `${visibleCount} satış noktası`;
    if (this.emptyState) this.emptyState.hidden = visibleCount > 0;
    if (this.clearButton) this.clearButton.hidden = !(city || district || query);
  }

  clearFilters() {
    if (this.cityFilter) this.cityFilter.value = '';
    if (this.districtFilter) this.districtFilter.value = '';
    if (this.searchInput) this.searchInput.value = '';
    this.updateDistrictOptions();
    this.filterStores();
  }
}

if (!customElements.get('novva-store-locator')) {
  customElements.define('novva-store-locator', NovvaStoreLocator);
}
